import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import BottomDrawer from '../Drawer/Drawer';
import themeColors from '../../assets/styles/themeColors';
// import SectionLoader from '../Loader/SectionLoader';
import { ReactComponent as ErrorWarningIcon } from '../../assets/images/svg/error-warning.svg';
import Button from '../Button/Button';
import Support from '../Support/Support';

const ErrorWarningIconWrapper = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 100%;
  background-color: ${themeColors.colorWarningnBackground};
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  margin-bottom: 12px;
`;

const ErrorTitle = styled.h2`
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  text-align: center;
  color: ${themeColors.colorTextPrimary};
  margin-bottom: 12px;
`;

const ErrorMessage = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  color: ${themeColors.colorTextSecondary};
  margin-bottom: 12px;
`;

const ErrorWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  > button {
    width: 100%;
  }
`;

const ErrorDrawer = ({
  open,
  errorMessage,
  errorTitle,
  onClose,
  isSupportOpen,
  closeSupport,
}) => {
  const { t } = useTranslation();

  if (isSupportOpen) {
    return (
      <BottomDrawer
        isOpen={open}
        onClose={() => {
          onClose();
          closeSupport();
        }}
        title={t(`support.contactSupport`)}
      >
        <Support />
      </BottomDrawer>
    );
  }

  return (
    <BottomDrawer isOpen={open} onClose={onClose} hideClose>
      {/* <SectionLoader isLoading={isLoading}> */}
      <ErrorWrapper>
        <ErrorWarningIconWrapper>
          <ErrorWarningIcon />
        </ErrorWarningIconWrapper>
        {errorTitle && <ErrorTitle>{errorTitle}</ErrorTitle>}
        {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
        <Button
          textTransform="capitalize"
          variant="primaryOutlined"
          size="sm"
          onClick={onClose}
        >
          {t('common.ok')}
        </Button>
      </ErrorWrapper>
      {/* </SectionLoader> */}
    </BottomDrawer>
  );
};

ErrorDrawer.propTypes = {
  open: PropTypes.bool,
  wizardData: PropTypes.shape({}),
  // isLoading: PropTypes.bool,
  errorMessage: PropTypes.PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.string,
  ]),
  errorTitle: PropTypes.string,
  onClose: PropTypes.func,
  closeSupport: PropTypes.func,
  isSupportOpen: PropTypes.bool,
};

export default ErrorDrawer;
